import React from 'react';
import { Icon } from '@iconify/react';
import '../../styles/app-filter-bar.scss';

/**
 * Barre de filtres compacte (look unique site-wide).
 * Alias visuel de l'ancienne card planning KKP.
 */
export default function AppFilterBar({
  children,
  onReset,
  resetDisabled = false,
  showReset = true,
  title = 'Filtres',
  showTitle = true,
  className = '',
}) {
  return (
    <div className={`card mb-3 app-filter-bar kkp-planning-filters-card ${className}`.trim()}>
      <div className="card-body">
        {showTitle ? (
          <div className="app-filter-bar__title">
            <Icon icon="mdi:filter-variant" width={18} height={18} aria-hidden />
            <span>{title}</span>
          </div>
        ) : null}
        <div className="row g-2 g-md-3 align-items-end app-filter-bar__grid kkp-planning-filters__grid">
          {children}
          {showReset && onReset ? (
            <AppFilterResetButton onClick={onReset} disabled={resetDisabled} />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export function AppFilterField({
  col = 'col-6 col-md-3 col-lg-2',
  label,
  htmlFor,
  children,
  className = '',
}) {
  return (
    <div className={`${col} ${className}`.trim()}>
      {label ? (
        <label className="form-label" htmlFor={htmlFor}>{label}</label>
      ) : null}
      {children}
    </div>
  );
}

export function AppFilterInput({
  id,
  label,
  value,
  onChange,
  type = 'search',
  placeholder = '',
  disabled = false,
  col = 'col-12 col-md-6 col-lg-3',
  className = '',
  ...rest
}) {
  const handleChange = (event) => {
    if (typeof onChange === 'function') {
      onChange(event.target.value, event);
    }
  };

  return (
    <AppFilterField col={col} label={label} htmlFor={id} className={className}>
      <input
        id={id}
        type={type}
        className="form-control form-control-sm"
        placeholder={placeholder}
        value={value ?? ''}
        onChange={handleChange}
        disabled={disabled}
        {...rest}
      />
    </AppFilterField>
  );
}

export function AppFilterResetButton({
  onClick,
  disabled = false,
  title = 'Réinitialiser les filtres',
}) {
  return (
    <div className="col-auto app-filter-bar__reset-wrap kkp-planning-filters-card__reset-wrap">
      <label className="form-label" aria-hidden="true">&nbsp;</label>
      <button
        type="button"
        className="btn btn-outline-secondary btn-sm app-filter-bar__reset kkp-planning-filters-card__reset"
        onClick={onClick}
        disabled={disabled}
        title={title}
        aria-label={title}
      >
        <Icon icon="mdi:filter-off-outline" width={16} height={16} />
      </button>
    </div>
  );
}
